import { Injector, OnInit } from '@angular/core';
import { ActiveModal, ChassisFormHandler, TenantModel, TenantService } from '@kaiser-software/chassis-core';
import { TenantLocationService } from '../services/tenant-location.service';

export class LocationModal implements OnInit {

    public loading: any;

    public form: ChassisFormHandler;

    public model: TenantModel;

    protected tenantService: TenantService;

    protected tenantLocationService: TenantLocationService;

    constructor(protected injector: Injector, protected modal: ActiveModal) {
        this.tenantService         = injector.get(TenantService);
        this.tenantLocationService = injector.get(TenantLocationService);
    }

    ngOnInit() {
        this.setModalButtons();

        this.loading = this.modal.get('loading');
    }

    protected setModalButtons() {
        const buttons = this.modal.get<Map<string, any>>('buttons');

        this.setSubmitModalButton(buttons);
    }

    protected setSubmitModalButton(buttons) {
        buttons.get('ok').callback = () => {
            return this.submitButtonCallback();
        };
    }

    private submitButtonCallback() {
        this.loading.start();

        const url = this.tenantService.getEndpointUrl() + '/validate';

        const request = this.tenantService.custom('post', url, this.model.plain());
        request.subscribe(() => {
            this.modal.close(this.model);
        }, (error) => {
            console.error(error);
            this.loading.stop();
        });
    }

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/locations/modals/location-modal.ts